
/**
 * h5路由枚举，用于重构之前的页面
 */
export const h5Routes = {
  '/pages/battery/index': '/user-center/battery', // 我的电池
  '/pages/bike/index': '/user-center/bike', // 我的车辆
  '/pages/bike/rebind/index': '/user-center/bike/rebind', // 重新绑车
  '/pages/user_center/index': '/user-center', // 个人中心
  '/pages/user_center/user_info/index': '/user-center/user-info', // 个人资料
  '/pages/user_center/coupon/index': '/user-center/coupon', // 我的优惠券
  '/pages/user_center/user_packages/index': '/user-center/package', // 我的套餐
  '/pages/user_center/new_insurance/index': '/user-center/insurance', // 我的保险
  '/pages/unlock/index': '/unlock', // 开门页
  '/pages/packages/index': '/package', // 套餐
  '/pages/deposit/index': '/deposit', // 押金
  '/pages/record/index': '/user-center/record', // 换电记录
  '/pages/manual_input/index': '/manual_input', // 手动输入开电柜
};

/**
 * 判断是否是换电h5重构项目
 * @param {string} fullPath
 * @param {Function} next
 */
export function isPowerH5Url(fullPath, next = () => {}) {
  if (!fullPath) return false;
  const [_url, ...rest] = fullPath.split('?');
  const url = _url.charAt(0) === '/' ? _url : `/${_url}`;
  if (h5Routes[url]) {
    next([h5Routes[url], ...rest].join('?'));
    return true;
  }
  return false;
}
